"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)("position:absolute;z-index:1000;border-radius:10px;border:1px solid ", theme.border, ";background-color:#ffffff;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);margin-top:8px;" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  icon: theme => /*#__PURE__*/(0, _react.css)("button:hover,button:focus{&>svg>polygon,&>svg>path{fill:", theme.btnHoverTextColor, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:icon;")),
  background: bg => /*#__PURE__*/(0, _react.css)("button{background-color:", bg, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:background;"))
};
var _default = exports.default = styles;